import React__default from 'react';
import './Chip.scss.js';
import { classnames } from '../../../utils/classnames.js';
import Tooltip from '../Tooltip/Tooltip.js';
import AllClose from '../../../assets/icons/resultDir/AllClose.js';

var Chip = function Chip(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      onRemove = _ref.onRemove,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 's' : _ref$size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'primary' : _ref$type,
      icon = _ref.icon,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? 'left' : _ref$iconPosition,
      badge = _ref.badge,
      disabled = _ref.disabled,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === void 0 ? 32 : _ref$maxLength,
      _ref$tooltipBackgroun = _ref.tooltipBackground,
      tooltipBackground = _ref$tooltipBackgroun === void 0 ? 'white' : _ref$tooltipBackgroun,
      _ref$isBubble = _ref.isBubble,
      isBubble = _ref$isBubble === void 0 ? false : _ref$isBubble,
      _ref$multiline = _ref.multiline,
      multiline = _ref$multiline === void 0 ? false : _ref$multiline,
      className = _ref.className,
      style = _ref.style;

  var handleClick = function handleClick(e) {
    e.preventDefault();
    !isBubble && e.stopPropagation();

    if (!disabled) {
      onClick === null || onClick === void 0 ? void 0 : onClick();
    }
  };

  var handleRemove = function handleRemove(e) {
    e.stopPropagation();

    if (!disabled) {
      onRemove === null || onRemove === void 0 ? void 0 : onRemove();
    }
  }; // -------------------------------------------------------------------------------------------------------------------


  var clickableClass = onClick && !disabled ? 'rf-chip--clickable' : ''; // -------------------------------------------------------------------------------------------------------------------

  var overMaxLength = typeof children === 'string' && children.length > maxLength; // -------------------------------------------------------------------------------------------------------------------

  var button = /*#__PURE__*/React__default.createElement("div", {
    onClick: handleClick,
    tabIndex: 0,
    className: classnames('rf-chip', "rf-chip--".concat(type), "rf-chip--".concat(size), multiline && 'rf-chip__multiline', disabled && 'rf-chip--disabled', clickableClass, className),
    style: style,
    "data-v-6e52f9c7": ""
  }, !!icon && iconPosition === 'left' && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-chip__icon rf-chip__icon--left",
    "data-v-6e52f9c7": ""
  }, icon), overMaxLength ? children.slice(0, maxLength) + '...' : children, onRemove && /*#__PURE__*/React__default.createElement("button", {
    className: classnames('rf-chip__icon', 'rf-chip__icon--right'),
    onClick: handleRemove,
    disabled: disabled,
    type: "button",
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement(AllClose, {
    size: size === 's' ? 'xxs' : 'xxxs',
    "data-v-6e52f9c7": ""
  })), !!icon && iconPosition === 'right' && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-chip__icon rf-chip__icon--right",
    "data-v-6e52f9c7": ""
  }, icon), !!badge && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-chip__badge",
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "rf-chip__badge-text",
    "data-v-6e52f9c7": ""
  }, badge)));

  if (!overMaxLength) {
    return button;
  }

  return /*#__PURE__*/React__default.createElement(Tooltip, {
    background: tooltipBackground,
    position: "bottom",
    isVisible: overMaxLength,
    "data-v-6e52f9c7": ""
  }, button, children);
};

export { Chip as default };
